import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.transaction
 * @constructor
 */
export class TransitionModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} name
   * @param {Array<string>} actors
   * @param {Array<string>} actions
   * @param {Object} requiredParameters
   * @param {Object} optionalParameters
   */
  constructor({
    id,
    name,
    actors,
    actions,
    requiredParameters,
    optionalParameters,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.name = name

    /** @type {Array<string>} */
    this.actors = actors

    /** @type {Array<string>} */
    this.actions = actions

    /**
     * A transition can have parameters which need to be included
     * when posted to the Marketplace API. These required parameters
     * are declared here as an object. The key stands for the parameter name
     * and the value is the data type
     * @example {
     *   reviewRating: 'number',
     *   reviewContent: 'string',
     * }
     * @type {Object}
     */
    this.requiredParameters = requiredParameters

    /**
     * See description of 'requiredParameters'
     * @type {Object}
     */
    this.optionalParameters = optionalParameters
  }
}

// All possible transitions within a transaction process.
// This transaction process can be found here:
// https://flex-console.sharetribe.com/ > Build > Transaction processes
export const TRANSITION_NAMES = {
  ENQUIRE: 'transition/enquire',
  CANCEL_PURCHASE: 'transition/cancel-purchase',
  CANCEL_PURCHASE_BY_OPERATOR: 'transition/cancel-purchase-by-operator',
  CANCEL_PAYMENT_BY_OPERATOR: 'transition/cancel-payment-by-operator',
  FAILED_PAYMENT: 'transition/failed-payment',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
  SEND_ITEM: 'transition/send-item',
  ITEM_NOT_SENT: 'transition/item-not-sent',
  DELIVERED: 'transition/delivered',
  NOT_DELIVERED: 'transition/not-delivered',
  REVIEW_BY_CUSTOMER: 'transition/review-by-customer',
  COMPLETE_BY_OPERATOR: 'transition/complete-by-operator',
  COMPLETE_BY_CUSTOMER: 'transition/complete-by-customer',
  DISPUTE_BY_CUSTOMER: 'transition/dispute-by-customer',
  REFUND_NOT_DELIVERED: 'transition/refund-not-delivered',
  DISPUTE_RESOLVED_BY_CUSTOMER: 'transition/dispute-resolved-by-customer',
  DISPUTE_RESOLVED_BY_OPERATOR: 'transition/dispute-resolved-by-operator',
  REFUND_AFTER_DISPUTE: 'transition/refund-after-dispute',
  REFUND_AFTER_DISPUTE_BY_OPERATOR: 'transition/refund-after-dispute-by-operator',
}

export const ACTORS = {
  CUSTOMER: 'customer',
  PROVIDER: 'provider',
  OPERATOR: 'operator',
  SYSTEM: 'system',
}
